import { Link } from 'react-router-dom';

import config from '@/config';
import NewspaperArticleMeta from '@/pages/newspaper/slider-types/components/NewspaperArticleMeta';
import { NewspaperArticleReadTime } from '@/pages/newspaper/slider-types/components/NewspaperArticleMeta';
import Text from '@/shared-components/text/components/Text';
import { buildPublicContentPath } from '@/utils/contentRoutes';

import './styles/NewspaperStatic.css';

function buildArticleLink(article = {}) {
  return article._id ? buildPublicContentPath({ ...article, post_type: 'article' }, 'article') : '#';
}

function NewspaperStaticItem({ article }) {
  const articleLink = buildArticleLink(article);
  const coverImage = article.coverImageId
    ? `${config.app.imageServiceDomain}/${article.coverImageId}/w=1400`
    : null;

  return (
    <Link
      to={articleLink}
      className="newspaper-static__item"
    >
      {coverImage && (
        <>
          <img
            className="newspaper-static__backdrop"
            src={coverImage}
            alt=""
            aria-hidden="true"
            loading="lazy"
          />
          <span className="newspaper-static__backdrop-scrim" aria-hidden="true" />
        </>
      )}

      <div className="newspaper-static__media">
        {coverImage ? (
          <img
            src={coverImage}
            alt={article.title || 'Article cover'}
            loading="lazy"
          />
        ) : (
          <div className="newspaper-static__media-placeholder" aria-hidden="true" />
        )}
      </div>

      <div className="newspaper-static__content">
        <NewspaperArticleMeta
          date={article.createdAt}
          className="newspaper-static__meta"
          dateClassName="newspaper-static__date"
        />

        <h3 className="newspaper-static__headline">{article.title}</h3>

        {article.description && (
          <Text className="newspaper-static__summary" paragraph>
            {article.description}
          </Text>
        )}

        <div className="newspaper-static__footer">
          <NewspaperArticleReadTime
            article={article}
            className="newspaper-static__read-time"
          />
        </div>
      </div>
    </Link>
  );
}

export default function NewspaperStatic({
  articles = [],
}) {
  const curatedArticles = [...articles]
    .filter(article => {
      const author = (article?.creator_username || article?.creator_name || '').toLowerCase();
      return author === 'suarte';
    })
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
    .slice(0, 3);

  const fallbackSorted = [...articles]
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));

  const displayArticles = (curatedArticles.length > 0 ? curatedArticles : fallbackSorted)
    .slice(0, 3);

  if (displayArticles.length === 0) {
    return null;
  }

  return (
    <div className="newspaper-static__list">
      {displayArticles.map(article => (
        <NewspaperStaticItem
          key={article._id || article.slug || article.article_slug}
          article={article}
        />
      ))}
    </div>
  );
}
